import { render } from "preact";
import "./styles/index.css";
import "./settings/store"; // loads the saved settings from localStorage (gunrun.settings.v1)
import { App } from "./app/App";
import { installBootEffects, runBoot } from "./app/boot";
import { installGameSession } from "./game/controller";
import { PERF } from "./perf/probe";

const container = document.getElementById("app");
if (!container) throw new Error("#app element missing from index.html");

if (PERF) void import("./perf/hooks");
installBootEffects();
installGameSession();
render(<App />, container);
void runBoot();
